import { lazy } from "react"

export const AuthorizationLostPage = lazy(() => import("./AuthorizationLostPage"))
